import _ from 'lodash';

/**
 * intended to be used as a way to differentiate between the Form Designer/Page Designer/Screen Designer modes, to show/hide fields in module editors
 */
const designerTypes = {
  ENTRY_FORM:   'entryForm', //new form designer, when used inside an experience
  LIBRARY_FORM: 'libraryForm', //new form designer, when used in the global library assets
  FOOTER:       'footer', //new footer form designer, when used in the design section
  HEADER:       'header', //new header form designer, when used in the design section
  PAGE:         'page', //macro page designer
  SCREEN:       'screen', //micro screen designer
  PROMOTION:    'promotion', //micro promotion designer
};

designerTypes.ALL = _.values(designerTypes);

designerTypes.isLibraryFormDesigner = (designerType) => designerType === designerTypes.LIBRARY_FORM;

designerTypes.isEntryFormDesigner = (designerType) => designerType === designerTypes.ENTRY_FORM;

designerTypes.isPromotionDesigner = (designerType) => designerType === designerTypes.PROMOTION;

designerTypes.isFormDesigner = _.memoize(
  (designerType) =>
    designerTypes.isEntryFormDesigner(designerType) || designerTypes.isLibraryFormDesigner(designerType),
  (designerType) => `cache-${designerType}`
);

designerTypes.isScreenDesigner = (designerType) => designerType === designerTypes.SCREEN;

designerTypes.isPageDesigner = (designerType) => designerType === designerTypes.PAGE;

designerTypes.isFooterDesigner = (designerType) => designerType === designerTypes.FOOTER;

designerTypes.isHeaderDesigner = (designerType) => designerType === designerTypes.HEADER;

designerTypes.isSectionDesigner = _.memoize(
  (designerType) => _.includes([designerTypes.HEADER, designerTypes.FOOTER], designerType),
  (designerType) => `cache-${designerType}`
);

designerTypes.isScreenOrPromotionDesigner = _.memoize(
  (designerType) => _.includes([designerTypes.PROMOTION, designerTypes.SCREEN], designerType),
  (designerType) => `cache-${designerType}`
);

// Attempt to better groupping the mostly used the combinated designer types:
// NextGen = Header, Footer, Screen
designerTypes.isNextGenDesigner = _.memoize(
  (designerType) => _.includes([designerTypes.FOOTER, designerTypes.HEADER, designerTypes.SCREEN], designerType),
  (designerType) => `cache-${designerType}`
);

designerTypes.isNextGenOrPromotionDesigner = _.memoize(
  (designerType) =>
    _.includes(
      [designerTypes.FOOTER, designerTypes.HEADER, designerTypes.SCREEN, designerTypes.PROMOTION],
      designerType
    ),
  (designerType) => `cache-${designerType}`
);

designerTypes.isLayoutDesigner = _.memoize(
  (designerType) =>
    designerTypes.isFormDesigner(designerType) || designerTypes.isNextGenOrPromotionDesigner(designerType),
  (designerType) => `cache-${designerType}`
);

export default designerTypes;
